import items from "../config/faqdata";
import Popup from "reactjs-popup";
import { Icon } from "@iconify/react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useState } from "react";

const Faqfunc = () => {
  const [isOpenModel, setIsOpenModel] = useState(false)

  return (
    <>
      <Popup
        trigger={
          <button className="absolute flex items-center gap-1 right-2 top-1 md:right-10 md:top-6">
            <Icon icon="mdi:faq" color="orange" width="25" height="25" />
            <span className="font-medium">FAQ</span>
          </button>
        }
        modal
        nested
      >
        {(close) => (
          <div className="modal">
            <button
              className="close w-fit absolute right-4 top-2 text-xl border px-2 bg-slate-400 rounded-2xl text-white"
              onClick={close}
            >
              &times;
            </button>
            <div className="header text-center font-bold">
              {" "}
              <h1 className="text-2xl font-semibold text-center text-orange-400">
                <u>DDPI FAQ</u>
              </h1>
            </div>
            <br />
            <div className="">
              <div className="rounded">
                <Accordion allowZeroExpanded>
                  {items.map((item) => (
                    <AccordionItem key={item.id}>
                      <AccordionItemHeading>
                        <AccordionItemButton
                          style={{ fontSize: "14px", fontWeight: "600" }}
                        >
                          {item.title}
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel
                        style={{
                          fontSize: "14px",
                          padding: "10px 20px",
                          color: "gray",
                        }}
                      >
                        {item.content}
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton
                        style={{ fontSize: "14px", fontWeight: "600" }}>
                        What are the steps to activate DDPI?
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel
                      style={{
                        fontSize: "14px",
                        padding: "10px 20px",
                        color: "gray",
                      }}
                    >
                      <div>
                        There are few steps to activate DDPI at Almondz:<br />
                        1. Go to &nbsp; <a className="text-blue-400" href="https://ddpi.almondztrade.com" target="_blank">
                          www.ddpi.almondztrade.com
                        </a>
                        <br />
                        2. Enter your Client Code.
                        <br />
                        3. Enter the OTP sent to your registered mobile number and email.
                        <br />
                        4. To proceed with e-Stamp, please make a payment of Rs. 125.
                        <br />
                        5. Check the E-stamp page and proceed.
                        <br />
                        6. Enter your Aadhaar number and verify it to e-sign your DDPI.
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                </Accordion>
              </div>
            </div>
          </div>
        )}
      </Popup>

    </>
  );
};
export default Faqfunc;
